<template>
  <div>
    <v-row>
      <v-col cols="3" class="mt-0 py-4">
        <strong class="text-green">Jetzt sparen</strong>:
      </v-col>
      <v-col cols="9" class="mt-0 py-4">
        Bis zum
        <strong>15.12.{{ tarif.show_begrenzung_vorteil }}</strong>
        zusätzlich
        <strong class="text-green">{{ tarif.tarif_int_begrenzung_1 }} €</strong>
        Erstattung sichern.
        <a @click="berechnungStore.setShowPop(tarif, 'begrenzungrumpfjahr')"
          >Mehr Infos dazu...</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";

  //   import { useBerechnungStore } from "@/stores/berechnung";
  //   import { useSharedDataStore } from "@/stores/sharedData";
  //   const sharedDataStore = useSharedDataStore();
  //   const berechnungStore = useBerechnungStore();

  const props = defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });
  console.log(props.tarif);
</script>
